export default __webpack_public_path__ + "static/media/veilspun.8dfd6684.png";